import { useI18n } from "@wojo/localization";
import { StatusLabel, Text } from "@wojo/ui";
import React from "react";
import { getCurrency } from "../../../../hooks";
import styles from "./TripBuilderDeparturesStep.module.scss";

export type DepartureListPriceCellProps = {
    onSale?: boolean;
    fullPrice: number | null;
    salePrice?: number | null;
    discountAmount?: number | null;
};

export const DepartureListPriceCell: React.FC<DepartureListPriceCellProps> = ({
    fullPrice,
    onSale,
    salePrice,
    discountAmount,
}) => {
    const { formatCurrency } = getCurrency();
    const { productPage } = useI18n("productPage");

    if (!fullPrice) {
        return null;
    }

    const showSalePrice = !!(onSale && salePrice && discountAmount);
    const formattedFullPrice = formatCurrency(fullPrice);
    const formattedSalePrice = formatCurrency(salePrice || 0);
    const formattedDiscountAmount = formatCurrency(discountAmount || 0);
    const discountLabel = productPage.tripBuilder.departures.discountLabel.l({
        discountAmount: formattedDiscountAmount,
    });
    return (
        <td className={styles["table-cell"]}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Text.Body
                    tag="span"
                    aria-hidden={onSale || undefined}
                    style={{
                        textDecoration: onSale ? "line-through" : undefined,
                    }}
                >
                    {formattedFullPrice}
                </Text.Body>
                {showSalePrice && (
                    <>
                        <Text.Body
                            tag="span"
                            emphasis="1"
                            aria-hidden
                            style={{
                                color: "var(--s-color-promo-price-standard)",
                            }}
                        >
                            {formattedSalePrice}
                        </Text.Body>
                        <StatusLabel
                            variant="secondary"
                            status="deal"
                            size="small"
                            aria-hidden
                            text={discountLabel}
                        />
                        <p className="visually-hidden">
                            {formattedSalePrice}, {discountLabel}{" "}
                            {formattedFullPrice}
                        </p>
                    </>
                )}
            </div>
        </td>
    );
};
